import { useState } from 'react';
import { PageShell } from '../viewir/components/chrome';
import { Padding, Surface, Text } from '../viewir/components/primitives';
import { PageHeaderHostContext } from '../viewir/pageHeaderContext';

const MODES = [
  ['legacy', 'Legacy'],
  ['collapsing', 'CollapsingHeader'],
  ['fixed', 'FixedHeader'],
  ['custom', 'CustomHeader'],
];

/** 使用真实 PageShell 展示头部模式；滚动与返回均在预览内验证，不离开组件库。 */
export default function HeaderPreview() {
  const [mode, setMode] = useState('collapsing');
  const [safeArea, setSafeArea] = useState(true);
  const [backRequested, setBackRequested] = useState(false);
  const customHeader = <Surface key="custom-header" variant="plain" props={{ backgroundColor: '#eaf4ed' }}>
    <Padding props={{ left: 64, right: 16, top: 9, bottom: 9 }}>
      <Text variant="title" props={{ value: 'My Garden', align: 'start' }} />
    </Padding>
    <Padding props={{ left: 16, right: 16, bottom: 12 }}>
      <Text props={{ value: 'Background fills the header; only the title is inset.' }} />
    </Padding>
  </Surface>;
  const childItems = [
    ...(mode === 'custom' ? [{ id: 'custom-header', region: 'header', element: customHeader }] : []),
    ...Array.from({ length: 12 }, (_, i) => ({
      id: `row-${i}`, type: 'Text', element: <p key={i} style={{ margin: 0, padding: '12px 0' }}>Garden entry {i + 1}</p>,
    })),
  ];
  return <div>
    <div role="group" aria-label="Header mode" style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
      {MODES.map(([value, label]) => <button key={value} type="button" aria-pressed={mode === value}
        onClick={() => { setMode(value); setBackRequested(false); }}
        style={{ font: 'inherit', fontSize: 11, padding: '6px 8px', borderRadius: 6, cursor: 'pointer',
          border: '1px solid var(--line)', background: mode === value ? 'var(--accent-soft)' : 'var(--surface)', color: 'var(--text)' }}>
        {label}
      </button>)}
    </div>
    <p style={{ fontSize: 12, margin: '0 0 10px', color: 'var(--text-2)' }}>
      PageShell · headerStyle: {mode === 'legacy' ? 'omitted' : mode}. Scroll inside the preview.
    </p>
    {mode === 'custom' && <label style={{ display: 'block', fontSize: 12, marginBottom: 10 }}>
      <input type="checkbox" checked={safeArea} onChange={(event) => setSafeArea(event.target.checked)} /> Respect top safe area
    </label>}
    <div style={{ height: 320, overflow: mode === 'legacy' ? 'auto' : 'hidden', border: '1px solid var(--line)', borderRadius: 12 }}>
      <PageHeaderHostContext.Provider value={{ safeTop: 24, leading: <button type="button" aria-label="Preview back"
        onClick={() => setBackRequested(true)}
        style={{ width: 36, height: 36, borderRadius: 18, border: '1px solid #E3E3E3', background: 'white', color: '#1C1C1E', cursor: 'pointer' }}>←</button> }}>
        <PageShell key={mode} props={{ title: 'My Garden', subtitle: 'Plants and places you saved', layout: 'single',
          ...(mode !== 'legacy' ? { headerStyle: mode } : {}), headerSafeArea: safeArea }} childItems={childItems} />
      </PageHeaderHostContext.Provider>
    </div>
    <div role="status" style={{ fontSize: 12, minHeight: 18, marginTop: 8, color: 'var(--text-2)' }}>
      {backRequested ? 'Host back requested' : 'Header modes share the same host back action.'}
    </div>
  </div>;
}
